import firebase from "firebase";

const config = {
  apiKey: "AIzaSyBTPPSG4a62Z-LsARFRhTnWWyqbHjoVHpM",
  authDomain: "diet-z.firebaseapp.com",
  storageBucket: "diet-z.appspot.com",
  databaseURL: "https://diet-z.firebaseio.com",
  projectId: 'diet-z',
  appId: '1:387933989796:web:f49feeaed8b72636d22f31',
  messagingSenderId: "387933989796",
};

firebase.initializeApp(config);

firebase.auth().signInAnonymously().then(()=>{

}).catch(function(error) {

});

export default firebase;
